import { IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import type { SafeSource } from 'reactApp/modules/trashbin/safe.helpers';
import { sendDwh } from 'reactApp/utils/ga';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';

export const sendRecoverFromSafeButtonDwh = ({ action, source }: { action: 'show' | 'click'; source: SafeSource }) => {
    const dwhData = {
        name: 'recover_from_safe',
        paid_user: IS_PAID_USER,
        platform: getPlatformInfo().join('_'),
        source,
    };

    const dwh_enabled_fields: (keyof typeof dwhData)[][] = [['name', 'source', 'platform']];

    sendDwh({
        eventCategory: 'button',
        action,
        dwh_enabled: true,
        dwh_enabled_fields,
        dwhData,
    });
};
